import { IAdminSettingsState } from "@/features/adminSettingsSlice";
import { Features } from "@/ts/common-types";

export type AdminSettingConfig = {
    key: keyof IAdminSettingsState;
    label: string;
    toggleId: string;
    feature: Features;
    requiresActivationAccess?: boolean;
    requiresPlanningAccess?: boolean;
    requiresReviewAnalytics?: boolean;
    requiresProductAnalysis?: boolean;
  };
  
export  const ADMIN_SETTINGS_CONFIG: AdminSettingConfig[] = [
    {
      key: "dayparting",
      label: "Enable / Disable Day Parting",
      toggleId: Features.DAY_PARTING,
      feature: Features.DAY_PARTING,
      requiresActivationAccess: true,
    },
    {
      key: "buybox",
      label: "Enable / Disable Buybox",
      toggleId: Features.BUYBOX,
      feature: Features.BUYBOX,
      requiresActivationAccess: true,
    },
    {
      key: "revstack",
      label: "Enable / Disable Custom Reports",
      toggleId: Features.REVSTACK,
      feature: Features.REVSTACK,
      requiresPlanningAccess: true,
    },
    {
      key: "keywordRecommendation",
      label: "Enable / Disable Keyword Recommendation",
      toggleId: Features.KEYWORD_RECOMMENDATIONS,
      feature: Features.KEYWORD_RECOMMENDATIONS,
      requiresActivationAccess: true,
    },
    {
      key: "categoryAnalysis",
      label: "Enable / Disable Category Analysis",
      toggleId: Features.CATEGORY_ANALYSIS,
      feature: Features.CATEGORY_ANALYSIS,
      requiresPlanningAccess: true,
      requiresReviewAnalytics: true,
    },
    {
      key: "navigator",
      label: "Enable / Disable Navigator Access",
      toggleId: Features.NAVIGATOR,
      feature: Features.NAVIGATOR,
      requiresPlanningAccess: true,
      requiresReviewAnalytics: true,
    },
    {
      key: "productAnalysis",
      label: "Enable / Disable Product Analysis",
      toggleId: Features.PRODUCT_ANALYSIS,
      feature: Features.PRODUCT_ANALYSIS,
      requiresPlanningAccess: true,
      requiresProductAnalysis: true,
    },
  ];


  